import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","display":"block"} }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "800",
        persistent: ""
      }, {
        default: _withCtx(() => [
          (_ctx.location)
            ? (_openBlock(), _createBlock(_component_v_form, {
                key: 0,
                ref: "form",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
                modelValue: _ctx.valid,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { "primary-title": "" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            (_ctx.location.id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("message.close") + ' ' + _ctx.$tc("message.locationsType" + _ctx.model.locationsType + "Name",1).toLowerCase()), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("message.closeMessage")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                          _createVNode(_component_v_menu, {
                            color: "primary",
                            location: "bottom",
                            "close-on-content-click": false,
                            modelValue: _ctx.menu,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.menu) = $event))
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props, {
                                color: "primary",
                                onClick: _withModifiers(_ctx.toggleMenu, ["stop"])
                              }), {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("message.closeLocation")) + " ", 1),
                                  _createVNode(_component_v_icon, { right: "" }, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                      _createTextVNode("mdi-chevron-down", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 16, ["onClick"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        disabled: _ctx.location.changeType == 3,
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.save(_ctx.scenario.parentScenarioId == null? _ctx.scenario.id : _ctx.scenario.parentScenarioId)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("message.closeLocationInNewScenario")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        variant: "text",
                                        color: "primary",
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save(null))),
                                        disabled: _ctx.scenario.parentScenarioId == null
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("message.closeLocationInThisScenario")), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.model.scenarioHierarchy)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            variant: "text",
                                            color: "primary",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save(_ctx.scenario.id))),
                                            disabled: _ctx.scenario.parentScenarioId == null
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("message.closeLocationInNewNestedScenario")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: _ctx.cancel
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}